import {EgretLoadable} from "egret";
import { withTranslation } from "react-i18next";
const Layout1 = EgretLoadable({
  loader: () => import("./Layout1/Layout1")
});
const Layout2 = EgretLoadable({
  loader: () => import("./Layout2/Layout2")
});

const ViewComponent = withTranslation()(Layout1);

export const EgretLayouts = {
  layout1: ViewComponent,
  layout2: Layout2
}